const transfers = {
  transfer: "تحويل", // translated 
  transfers: "التحويلات", // translated 
  dateAndTime: "التاريخ و الوقت", // translated 
  transferFrom: "تحويل من", // translated 
  duration: "مدة", // translated 
  numOfPersons: "عدد الأشخاص", // translated 
  baggageAllowance: "حد الامتعة المسموح به", // translated 
  small: "صغير", // translated 
  big: "كبير", // translated 
  provider: "مزود", // translated 
  vehicle: "عربة", // translated 
  distance: "مسافة", // translated 
  price: "سعر", // translated 
  inboundJourney: "رحلة واردة", // translated 
  outboundJourney: "رحلة الى الخارج", // translated 
  arrivalTime: "وقت الوصول", // translated 
  flightDetails: "تفاصيل الرحلة", // translated 
  inboundPickupDate: "تاريخ الاستلام الوارد", // translated 
  outboundPickupDate: "تاريخ الاستلام للخارج", // translated 
  travelInfo: "معلومات السفر", // translated 
  flightsInfo: "معلومات الرحلات الجوية", // translated 
  airportYouAreFlyingFrom: "المطار الذي تسافر منه", // translated 
  airportYouAreFlyingTo: "المطار الذي ستسافر إليه", // translated 
  inboundFlightNumber: "رقم الرحلة القادمة", // translated 
  outboundFlightNumber: "رقم الرحلة المغادرة", // translated 
  inboundAirlineName: "اسم شركة الطيران القادمة", // translated 
  outboundAirlineName: "اسم شركة الطيران الصادرة", // translated 
  tripMode: "وضع الرحلة", // translated 
  airportToPoint: "المطار إلى النقطة", // translated 
  pointToAirport: "نقطة إلى المطار", // translated 
  roundTrip: "جولة", // translated 
  destinationPoint: "نقطة الوجهة", // translated 
  originPoint: "نقطة المنشأ", // translated 
  transferType: "نوع النقل", // translated 
  min: "دقيقة", // translated 
  max: "الأعلى", // translated 
  pieces: "قِطَع", // translated 
  cancelationIs: "الإلغاء هو", // translated 
};



export default transfers;
